@if(categoryFormReady()) {
    <form autocomplete="off" [formGroup]="categoryForm"
            class="form tw-p-5 tw-flex tw-flex-col tw-gap-5">
        <section class="tw-px-4 tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-x-4 tw-gap-y-3 tw-items-center">
    
            <div class="tw-col-span-12 tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-4 tw-pb-4">
                <div class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4 tw-flex tw-items-center">
                    <mat-slide-toggle formControlName="display" aria-label="{{'ITEMS.CATEGORIES.SHOW_IN_SALES_AND_ORDERS' | translate}}"
                        class="tw-p-3">{{'ITEMS.CATEGORIES.SHOW_IN_SALES_AND_ORDERS' | translate}}</mat-slide-toggle>
                </div>
                <div class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4 tw-flex tw-items-center">
                    <mat-slide-toggle formControlName="display_kiosk" aria-label="{{'ITEMS.CATEGORIES.SHOW_IN_KIOSK' | translate}}"
                        class="tw-p-3">{{'ITEMS.CATEGORIES.SHOW_IN_KIOSK' | translate}}</mat-slide-toggle>
                </div>
                <div class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4 tw-flex tw-items-center">
                    <mat-slide-toggle formControlName="display_slave_device" aria-label="{{'ITEMS.CATEGORIES.SHOW_ON_WAITER_DEVICES' | translate}}"
                        class="tw-p-3">{{'ITEMS.CATEGORIES.SHOW_ON_WAITER_DEVICES' | translate}}</mat-slide-toggle>
                </div>
            </div>
    
            <mat-form-field class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-8">
                <mat-label translate>ITEMS.CATEGORIES.NAME</mat-label>
                <input matInput formControlName="name" appTrimInput>
                @if(isAlternativeTranslateEnabled) {
                    <mat-icon 
                        matIconSuffix
                        #tooltip_orderName="matTooltip"
                        class="tw-cursor-pointer tw-text-gray-500"
                        [matTooltip]="'ITEMS.ALTERNATIVE_TRANSLATE' | translate"
                        matTooltipPosition="above"
                        (click)="manageAlternativeTranslate()" 
                        aria-label="'ITEMS.ALTERNATIVE_TRANSLATE' | translate">
                        language_outlined
                    </mat-icon>
                }
                <mat-hint [align]="'end'">{{categoryFormService.name?.value?.length || '0'}}
                    / {{categoryFormService.validators.nameMaxLength}}</mat-hint>
                @if(categoryFormService.name?.hasError('maxlength')) {
                    <mat-error>{{'NG_MESSAGES.NAME_TOO_LONG' | translate}} (max. {{categoryFormService.validators.nameMaxLength}})</mat-error>
                } @else if(categoryFormService.name?.hasError('required')) {
                    <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                }
            </mat-form-field>
    
            <mat-form-field class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4">
                <mat-label translate>ITEMS.CATEGORIES.INDEX</mat-label>
                <input matInput type="number" formControlName="index">
            </mat-form-field>
    
            <mat-form-field class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4">
                <mat-label translate>ITEMS.DETAILS.COLOR</mat-label>
                <mat-select formControlName="color" panelClass="no-select-panel-padding">
                    <mat-select-trigger>
                        <div class="tw-flex tw-items-center tw-gap-2">
                            @if(categoryFormService.color?.value) {
                                <span class="category-color-preview" [style.backgroundColor]="'#'+categoryFormService.color?.value"></span>
                            }
                            <span>{{ getSelectedColorName() }}</span>
                        </div>
                    </mat-select-trigger>
                    @for(color of colorList; track color.value) {
                        <mat-option [value]="color.value"
                            [ngStyle]="{'background-color': color.value ? '#' + color.value : 'none'}">
                            {{color.name | translate}}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
    
            <mat-form-field class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4">
                <mat-label translate>ITEMS.CATEGORIES.OVERRIDE_PRINTER</mat-label>
                <mat-select formControlName="printer_id">
                    @for(printer of printerList; track printer.id) {
                        <mat-option [value]="printer.id">{{printer.name}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
    
            <mat-form-field class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4">
                <mat-label translate>ITEMS.CATEGORIES.TERMINAL_ID</mat-label>
                <mat-select formControlName="terminal_id">
                    @for(terminal of terminalList; track terminal.id) {
                        <mat-option [value]="terminal.id">{{terminal.name}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>

            @if(isScaleCategoriesEnabled) {
                <mat-form-field class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4">
                    <mat-label translate>ITEMS.CATEGORIES.SCALE_CATEGORY</mat-label>
                    <input matInput type="number" formControlName="keyboard_code"
                        [min]="categoryFormService.validators.scaleCategoryMin" [max]="categoryFormService.validators.scaleCategoryMax">
                    <mat-hint>{{categoryFormService.validators.scaleCategoryMin}} - {{categoryFormService.validators.scaleCategoryMax}}</mat-hint>
                    @if(categoryFormService.keyboard_code?.invalid) {
                        <mat-error>{{'NG_MESSAGES.INVALID_VALUE' | translate}}</mat-error>
                    }
                </mat-form-field>
            }
    
            @for(price of priceList; track price.index) {
                <mat-form-field class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4">
                    <mat-label>{{price.departmentLabel}}</mat-label>
                    <mat-select [formControlName]="price.departmentFieldName" [required]="price.required">
                        @for(dep of departmentsList; track dep.id) {
                            <mat-option [value]="dep.id">{{dep.name}} {{itemDataOperationsService.getDepartmentVat(dep.vat)}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            }
        </section>
    
        <app-variations
            [categoryId]="category?.id || 0"
            [variationsData]="category?.variations || []"
        ></app-variations>
    </form>
}
